import {Injectable} from '@angular/core';
import {Meta, Title} from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class MetaService {
  constructor(
    private meta: Meta,
    private title: Title
  ) {
  }

  updateMetaTags(config: {
    title: string;
    description: string;
    image?: string;
    url?: string;
  }) {
    // Actualizar título
    this.title.setTitle(config.title);

    // Actualizar meta description
    this.meta.updateTag({
      name: 'description',
      content: config.description
    });

    // Open Graph
    this.meta.updateTag({
      property: 'og:title',
      content: config.title
    });
    this.meta.updateTag({
      property: 'og:description',
      content: config.description
    });
    if (config.image) {
      this.meta.updateTag({
        property: 'og:image',
        content: config.image
      });
    }
    if (config.url) {
      this.meta.updateTag({
        property: 'og:url',
        content: config.url
      });
    }

    // Twitter Card
    this.meta.updateTag({
      name: 'twitter:title',
      content: config.title
    });
    this.meta.updateTag({
      name: 'twitter:description',
      content: config.description
    });
    if (config.image) {
      this.meta.updateTag({
        name: 'twitter:image',
        content: config.image
      });
    }
  }
}
